<div [attr.aria-label]="'HängigeGeschäfte' | translate" class="mt-3">
  <cap-haengige-gb-geschaefte-icp [hasRight]="hasRight" [loadOption]="loadOption" [perimeter]="perimeter"></cap-haengige-gb-geschaefte-icp>

  <cap-haengige-geo-geschaefte-icp
    [hasRight]="hasRight"
    [loadOption]="loadOption"
    [perimeter]="perimeter"></cap-haengige-geo-geschaefte-icp>
</div>
